import React from "react";
import { Row, Col, Typography, Button,} from "antd";
import { AddButtonWithIcon } from "../../../components/AntCostomComponents/Buttons";

const { Title, Text } = Typography;

const PlaceholderView = ({
  image,
  title,
  description,
  imageWidth = "200px",
  buttonText="to go home",
  onButtonClick
}) => {
  return (
    <Row justify="center" align="middle" style={{ marginTop: "7rem" }}>
      <Col align="middle" style={{ textAlign: "center" }}>
        <Row justify="center" className="mb-6">
          <img src={image} alt="no-results" width={imageWidth} />
        </Row>
        <Title level={4} style={{ color: "#fff", textAlign: "center" }}>
          {title}
        </Title>
        <Text
          style={{
            color: "rgba(255, 255, 255, 0.7)",
            maxWidth: 500,
            fontSize: 17,
            display: "block",
            margin: "0 auto 24px",
            textAlign: "center",
          }}
        >
          {description}
        </Text>
        <AddButtonWithIcon text={buttonText} onClick={onButtonClick} /> 
      </Col>
         
    </Row>
  );
};

export default PlaceholderView;
